var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('Error',{attrs:{"statusCode":_vm.error.statusCode,"message":_vm.error.message}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }